import { SupporterErrorTypeEnum } from '@sola/schema/dotcom/supporters/errors.ts';
import type {
  GraphQLCommitment,
  GraphQLSupporterPaymentMethod,
} from '@sola/schema/dotcom/supporters/schema.generated.ts';

import { UserError } from '../errors-user.ts';

export const userInternalError = (statusCode = 500) =>
  new UserError({
    type: SupporterErrorTypeEnum.SupporterInternalError,
    statusCode,
  });

export const userErrorSupporterNotFound = (
  supporterId: string,
  statusCode = 400,
) => {
  return new UserError({
    type: SupporterErrorTypeEnum.SupporterNotFound,
    data: {
      supporterId,
    },
    statusCode,
  });
};

export const userErrorDuplicateSupporter = (statusCode = 409) => {
  return new UserError({
    type: SupporterErrorTypeEnum.SupporterDuplication,
    statusCode,
  });
};

export const userErrorPaymentMethodsEmpty = (
  supporterId: string,
  statusCode = 404,
) => {
  return new UserError({
    type: SupporterErrorTypeEnum.PaymentMethodsEmpty,
    data: {
      supporterId,
    },
    statusCode,
  });
};

export const userErrorPaymentMethodNotFound = (
  paymentMethodId: string,
  statusCode = 404,
) => {
  return new UserError({
    type: SupporterErrorTypeEnum.PaymentMethodNotFound,
    data: {
      paymentMethodId,
    },
    statusCode,
  });
};

export const userErrorPaymentMethodHasCommitments = (
  commitments: GraphQLCommitment[],
  statusCode = 409,
) =>
  new UserError({
    type: SupporterErrorTypeEnum.PaymentMethodHasCommitments,
    data: {
      commitments,
    },
    statusCode,
  });

export const userErrorPaymentMethodDelete = (statusCode = 500) =>
  new UserError({
    type: SupporterErrorTypeEnum.PaymentMethodDelete,
    statusCode,
  });

export const userErrorPaymentMethodCreate = (statusCode = 500) =>
  new UserError({
    type: SupporterErrorTypeEnum.PaymentMethodCreate,
    statusCode,
  });

export const userErrorPaymentMethodAssignToCommitment = (statusCode = 500) =>
  new UserError({
    type: SupporterErrorTypeEnum.PaymentMethodAssignToCommitment,
    statusCode,
  });

export const userErrorPaymentMethodAlreadyExists = (
  paymentMethod: GraphQLSupporterPaymentMethod,
  statusCode = 409,
) =>
  new UserError({
    type: SupporterErrorTypeEnum.PaymentMethodAlreadyExists,
    data: {
      paymentMethodId: paymentMethod.id,
    },
    statusCode,
  });

export const userErrorPaymentMethodUpdate = (statusCode = 500) =>
  new UserError({
    type: SupporterErrorTypeEnum.PaymentMethodUpdate,
    statusCode,
  });

export const userErrorPaymentMethodTokenUpdateNotAllowed = (
  paymentMethodId: string,
  statusCode = 400,
) => {
  return new UserError({
    type: SupporterErrorTypeEnum.PaymentMethodTokenUpdateNotAllowed,
    data: {
      paymentMethodId,
    },
    statusCode,
  });
};

export const userErrorAddressMissingField = (field: string, statusCode = 400) =>
  new UserError({
    type: SupporterErrorTypeEnum.AddressMissingRequiredField,
    data: {
      field,
    },
    statusCode,
  });
